import React from "react";
import TestsPageTemplate from "../components/TestsPageTemplate";
import {TEST_TYPES} from "../../../../shared/types/testTypes";

const Tests = () => {

    return (
        <TestsPageTemplate
            config={TEST_TYPES.school}
        />
    );
};

export default Tests;
